import React from 'react'

const Vegan = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_202_2352)">
                <path d="M8.21896 16.3391C8.14616 15.0791 8.79016 13.7575 9.85603 12.6281C10.9777 11.4543 11.7926 10.022 12.2286 8.458C12.3239 8.04295 12.4826 7.64504 12.699 7.27827C13.0566 6.68782 13.4917 6.14791 13.9926 5.67293C14.6347 5.11293 15.4168 5.11293 16.199 5.48626C18.0115 6.37106 18.8683 7.8868 18.6256 9.886C18.4456 11.1884 18.6217 12.5153 19.1352 13.7257C19.5608 14.7263 19.9622 15.7361 19.936 16.8599C19.88 19.3407 18.7899 21.1961 16.507 22.1967C14.196 23.2084 12.027 22.7828 10.1416 21.1196C8.81816 19.9548 8.22083 18.4353 8.21896 16.3391ZM17.4627 17.1007C17.4582 16.5214 17.338 15.9489 17.1091 15.4168C16.8802 14.8847 16.5473 14.4037 16.1299 14.002C14.8904 12.8223 13.2832 12.882 12.1894 14.2055C11.3141 15.244 10.8586 16.5723 10.9126 17.9295C10.9109 18.479 11.0817 19.0152 11.4008 19.4626C11.7199 19.91 12.1713 20.246 12.6915 20.4233C14.5899 21.0617 17.4795 19.7663 17.4627 17.0988V17.1007Z" fill="#86775E"/>
            </g>
            <defs>
                <clipPath id="clip0_202_2352">
                    <rect width="11.7245" height="17.5187" fill="white" transform="translate(8.21338 5.22656)"/>
                </clipPath>
            </defs>
        </svg>
    )
}

export default Vegan